<!--
 * @Author: weixiuting weixiuting@qq.com
 * @Date: 2022-11-23 11:40:49
 * @LastEditors: weixiuting weixiuting@qq.com
 * @LastEditTime: 2023-09-14 12:09:18
 * @FilePath: \plantingSubsidy_web\src\views\statistics-charts\insurance-statistics\components\InsuranceAreaProportion\index.vue
 * @Description: 承保理赔一张图-统计承保统计图- 最新 各保险公司承保情况-右侧
 -->
<template>
  <div class="chart_box"
       ref="insuranceAreaChart"
       style="width:100%;height:100%;">

  </div>

</template>
<script>
import moment from 'moment'
import imgSrc from '../../../images/chartCenter1.png'
export default {
  props: {

    // chartData: {
    //   type: Object,
    //   default: () => ({
    //     dataList: () => ([
    //       { value: 0, name: '水稻政策性保险' },
    //       { value: 0, name: '大豆政策性保险' },
    //       { value: 0, name: '玉米政策性保险' },
    //       { value: 0, name: '小麦政策性保险' }

    //     ])

    //   })
    // }

  },
  data () {
    return {
      dataList: [
        { value: 0, name: '水稻政策性保险' },
        { value: 0, name: '大豆政策性保险' },
        { value: 0, name: '玉米政策性保险' },
        { value: 0, name: '小麦政策性保险' }

      ],

      cityCode: '',
      imgSrc,
      chart: null

    }
  },
  created () {
    // this.cityCode = this.account.userArea.city
    // if (this.level <= 3) {
    //   // 各险种投保面积占比(%)
    //   this.initData()
    // }
  },
  mounted () {
    this.chart = this.$echarts.init(this.$refs.insuranceAreaChart)
    window.addEventListener('resize', () => {
      this.chart.resize()
    })
    this.initData()
  },
  methods: {

    initData () {
      let option = {
        color: ['#05C9D0', '#4392FD', '#F8AF30', '#422FF2'],

        tooltip: {
          // triggerOn: 'click',
          trigger: 'item',
          backgroundColor: '#103164',
          borderColor: '#2a69c6',
          className: 'custom_tooltip_box',
          // formatter: '{b}<br />面积占比：{d}%',
          position: function (point) {
            return [point[0] + 10, point[1] - 80]
          },
          formatter: function (params) {
            console.log('承保面积：', params)
            if (params.name) {
              let value = Number((params.value / 10000).toFixed(2)) || 0
              return `<div class='custom_tooltip_style'>
            <div class='custom_tooltip_inner'>${params.name}<br />承保面积：${value}万亩<br />面积占比：${params.percent}%</div>

            </div>`
            }

            // return '{b}<br />面积占比：{d}%'
          },
          padding: [4, 20, 5, 10],
          textStyle: {
            color: '#91b9f6'
          },
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '20%',
          right: '40%',
          // top: '4%',
          bottom: '30%'
        },
        legend: {
          icon: 'rect',
          orient: 'vertical',
          right: '0',
          top: 'middle',
          itemGap: 15,
          itemWidth: 10,
          itemHeight: 10,
          textStyle: {
            color: '#c6e1fc',
            fontSize: 13,
            // fontWeight: 'bold',
            padding: 4
          }
        },

        graphic: { // 这个属性可以在饼图内部填充图片,文字等
          elements: [{
            type: 'image', // 需要填充图片,配置image,如果不需要图片可以配置其他的, text, circle, sector, ring, polygon, polyline, rect, line, bezierCurve, arc, group,
            style: {
              image: this.imgSrc, // 这里添加图片地址
              width: this.chart.getWidth() * 0.19,
              height: this.chart.getWidth() * 0.19
            },
            // center: ['40%', '50%']
            left: 'center', //
            top: 'center' // 配置图片居中
          }]
        },
        series: [
          // 环形
          {
            type: 'pie',
            radius: ['62%', '80%'],
            center: ['50%', '50%'],
            hoverAnimation: false,
            label: {
              show: false // false不显示饼图上的标签
              // position: 'center', // inside（在饼图上显示）,outside(默认就会出现引导线) center
              // formatter: `${this.sum}亩`,
              // fontSize: 22,
              // lineHeight: 20,
              // fontWeight: 'bold',
              // color: '#FFFFFF'
              //   normal: {
              //     show: false
              //   },
              //   emphasis: {
              //     show: false
              //   }
            },
            emptyCircleStyle: {
              borderWidth: 4,
              borderColor: '#fff'
            },
            zlevel: 1,
            labelLine: {
              normal: {
                show: false
              }
            },
            data: this.dataList
          },
          // 外边框
          {
            name: '',
            type: 'pie',
            clockWise: true, // 顺时加载
            hoverAnimation: false, // 鼠标移入变大
            radius: ['90%', '90%'],
            center: ['50%', '50%'],
            label: {
              normal: {
                show: false
              }
            },
            data: [{
              value: 9,
              name: '',
              itemStyle: {
                normal: {
                  borderWidth: 1,
                  borderColor: '#283138'
                }
              }
            }]
          },
          // 内环
          {
            name: '',
            type: 'pie',
            clockWise: true, // 顺时加载
            hoverAnimation: false, // 鼠标移入变大
            radius: ['56%', '56%'],
            center: ['50%', '50%'],
            label: {
              normal: {
                show: false
              }
            },
            data: [{
              value: 9,
              name: '',
              itemStyle: {
                normal: {
                  borderWidth: 1,
                  // borderType: 'dashed',
                  borderColor: '#62676e',
                  borderType: [5, 10],

                  borderDashOffset: 4
                }
              }
            }]
          }

        ]
      }
      this.chart.setOption(option, true)
    }

  },
  watch: {
    dataList: {
      handler (val) {
        if (val) {
          this.initData()
        }
      },
      deep: true

    }
  }

}
</script>
<style lang="less" scoped>
.chart_box {
  height: 100%;
  position: relative;
  left: -3rem;

  // padding:0 0 30px;
  // display: flex;
}
/deep/.custom_tooltip_box {
  padding: 0 !important;
  border: none !important;
  background-color: transparent !important;
  height: auto !important;
  box-shadow: none !important;

  .custom_tooltip_style {
    position: relative;
    .custom_tooltip_inner {
      position: relative;
      z-index: 10;
      left: -10px;
      top: 0;
      // margin:40px;
      padding: 4px 20px 5px 10px;
      border: 1px solid #2a69c6;
      border-radius: 4px;
      background: #103164;
    }
    &::after {
      content: "";
      display: block;

      border-top: 30px solid transparent;
      border-left: 20px solid transparent;
      border-bottom: 30px solid transparent;
      border-right: 20px solid #103164;
      position: absolute;
      z-index: 0;
      bottom: -12px;
      left: -26px;
      // bottom: -16px;
      transform: rotate(45deg);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/statistics-charts/insurance-statistics/components/v1/InsuranceAreaProportion/index.vue